// @flow

import React, { useState } from "react";
import { GraphFileBrowser } from "@microsoft/file-browser";

import { app, request, group } from "./model/graph";
import logo from "./logo.png";
import "./Startup.css";

type Props = {
  onSelect: string => string
};

function SelectFile({ onSelect }: Props) {
  const getAuthenticationToken = () =>
    app.acquireTokenSilent(request).then(({ accessToken }) => accessToken);
  const onSuccess = keys => {
    const first = keys[0];
    const [key] = [...Object.keys(first)];
    const [, , id] = first[key];
    window.location.hash = "/" + id;
    onSelect(id);
  };
  return (
    <GraphFileBrowser
      getAuthenticationToken={getAuthenticationToken}
      onSuccess={keys => onSuccess(keys)}
      onCancel={err => console.log(err.message)}
      selectionMode="single"
      endpoint={`https://graph.microsoft.com/v1.0/groups/${group}`}
    />
  );
}

export default function Startup({ onSelect }: Props) {
  const account = app.getAccount();

  const [authorizing, setAuthorizing] = useState(false);
  const [error, setError] = useState(null);

  // if user is logged in, display file selection browser
  if (account) {
    if (window.location.hash) {
      let id = window.location.hash.split("/")[1];
      onSelect(id);
      return null;
    }
    return <SelectFile onSelect={id => onSelect(id)} />;
  }

  const login = async () => {
    setAuthorizing(true);
    try {
      await app.loginPopup(request);
      if (window.location.hash) {
        let id = window.location.hash.split("/")[1];
        onSelect(id);
      }
    } catch (error) {
      setError(error);
    }
    setAuthorizing(false);
  };

  if (error) {
    return (
      <div className="startup">
        <div>{String(error)}</div>
      </div>
    );
  }

  return (
    <div className="startup">
      <div>
        <img alt="logo" width="200" src={logo} />
        <div className="button" disabled={authorizing} onClick={() => login()}>
          {authorizing ? "Authorizing" : "Login"}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Startup.js